export const setAuthenticatedAction = (status) => ({
        type: '_Authentication_SetAuthenticated',
        payload: status,
    })

export const setErrorAction = (error) => ({
        type: '_Authentication_SetError',
        payload: error,
    })
